import { i18n } from "@tellescope/i18n";

export const getDaysOfWeek = () => [
  i18n.t("Sun", { ns: "calendar" }),
  i18n.t("Mon", { ns: "calendar" }),
  i18n.t("Tue", { ns: "calendar" }),
  i18n.t("Wed", { ns: "calendar" }),
  i18n.t("Thu", { ns: "calendar" }),
  i18n.t("Fri", { ns: "calendar" }),
  i18n.t("Sat", { ns: "calendar" }),
];
export const getDaysOfWeekFull = () => [
  i18n.t("Sunday", { ns: "calendar" }),
  i18n.t("Monday", { ns: "calendar" }),
  i18n.t("Tuesday", { ns: "calendar" }),
  i18n.t("Wednesday", { ns: "calendar" }),
  i18n.t("Thursday", { ns: "calendar" }),
  i18n.t("Friday", { ns: "calendar" }),
  i18n.t("Saturday", { ns: "calendar" }),
];
export const MONDAY_START_DAYS_OF_WEEK = [...getDaysOfWeek().slice(1), getDaysOfWeek()[0]!];

const DAY_COLUMN_LEFT_COLUMN_WIDTH = 75 as const;
const DAY_COLUMN_HOUR_BLOCK_HEIGHT = 96 as const;
export const DAY_COLUMN = {
  LEFT_COLUMN_WIDTH: DAY_COLUMN_LEFT_COLUMN_WIDTH,
  HOUR_BLOCK_COUNT: 24 as const,
  HOUR_BLOCK_HEIGHT: DAY_COLUMN_HOUR_BLOCK_HEIGHT,
  MINUTE_HEIGHT: DAY_COLUMN_HOUR_BLOCK_HEIGHT / 60,
} as const;

export const WEEK_VIEW = {
  GRID_TEMPLATE_COLUMNS: `${DAY_COLUMN_LEFT_COLUMN_WIDTH}px repeat(7, 1fr)` as const,
} as const;

export const DAY_VIEW = {
  GRID_TEMPLATE_COLUMNS: `${DAY_COLUMN_LEFT_COLUMN_WIDTH}px 1fr` as const,
} as const;

export const SNAP_INTERVAL_MINUTES = 15;
export const MIN_DURATION_MINUTES = 15;
export const DRAG_ACTIVATION_DISTANCE_PX = 4;

export const LOOKBACK_IN_MS_BY_VIEW: Record<string, number | undefined> = {
  month: undefined,
  week: 1000 * 60 * 60 * 24 * 2, // 2 days
};
